import {
	Directive,
	Input
} from '@angular/core';

import './VbHidden.less';

/**
 * Fork of ng-show. hides using the visibility property instead of display
 */
@Directive({
	selector: '[vbVisible]',
	host: {
		'[class.vb-hidden]': '!vbVisible'
	},
	standalone: false
})
export class VbVisibleDirective {
	@Input() public vbVisible: boolean;
}
